// Centralized user-facing labels (CODING_RULES: no hardcoded user-facing
// strings scattered in components).

export const PLAYBOOK_NAME_LABEL = 'Playbook Name';
export const PLAYBOOK_NAME_FIELD = 'playbookName';

// Copy-only rollback label while clients validate the "Playbook Name"
// wording; the `playbookName` wire key is intentionally NOT flag-gated.
// This constant is the only sanctioned home of the legacy label text.
const LEGACY_PLAYBOOK_NAME_LABEL = 'Industry';

/**
 * Feature flag for the playbook-name label copy. Defaults ON; set
 * REACT_APP_FEATURE_PLAYBOOK_NAME_LABEL=false to revert the visible label.
 * Read at call time (not module load) so the flag stays testable.
 */
export const isPlaybookNameLabelEnabled = (): boolean =>
  process.env.REACT_APP_FEATURE_PLAYBOOK_NAME_LABEL !== 'false';

export const getPlaybookNameLabel = (): string =>
  isPlaybookNameLabelEnabled() ? PLAYBOOK_NAME_LABEL : LEGACY_PLAYBOOK_NAME_LABEL;

// New Inquiry actions, shared by the post-call timeline, the dashboard's New
// Inquiries modal and the training session timeline.
export const ADD_TO_KNOWLEDGE_BASE_LABEL = 'Add/Modify Knowledge Base';
export const MARK_INQUIRY_PROCESSED_LABEL = 'Mark as Processed';
export const INQUIRY_PROCESSED_LABEL = 'Processed';
